import { mimeTypeForHeader } from '@/_data/mimeTypeForHeader';

const getFileHeader = (file: File): Promise<string> => {
    return new Promise((resolve) => {
        let fileReader = new FileReader();
        fileReader.onloadend = (event) => {
            let subarray = new Uint8Array(event.target?.result as ArrayBuffer).subarray(0, 4);
            let header = '';
            subarray.forEach((byte) => {
                header += byte.toString(16);
            });
            return resolve(header);
        };
        fileReader.readAsArrayBuffer(file);
    });
};

export const checkFiles = async (file: File) => {
    if (file.size > 4000000) {
        //return Promise.reject('Die Datei ist zu groß. Bitte laden Sie eine Datei hoch, die maximal 4mb groß ist.');
        throw new Error('Die Datei ist zu groß. Bitte laden Sie eine Datei hoch, die maximal 4mb groß ist.');
    }

    const header = await getFileHeader(file);
    if (header && mimeTypeForHeader(header as string) !== 'unknown') {
        return Promise.resolve('success');
    } else {
        throw new Error(
            'Der Dateityp ist nicht erlaubt. Bitte laden Sie Ihren Nachweis im Format .pdf, .jpg, .png, .mp4, .mov hoch.'
        );
    }
};
export default checkFiles;
